import geniatech from "../../../services/apis/geniatech";
import { stringify } from 'qs';
import * as type from "../../../services/types/location-type";
import {toast} from "react-toastify";

export const getCountries = () => async (dispatch) => {
    geniatech
        .post('/index.php', stringify({ action: 'get_list_of_regions' }))
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: type.GET_COUNTRIES,
                    payload: res.data.items,
                });
            }
        })
        .catch(() => {
            toast.error('Unable to get cities');
        });
};

export const getCities = (data) => async (dispatch) => {
    dispatch({ type: type.GETTING_CITIES, payload: true });
    geniatech
        .post('/index.php', data)
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: type.GET_CITIES,
                    payload: res.data.items,
                });
            }
        })
        .catch(() => {
            toast.info('Unable to get cities');
            dispatch({ type: type.GETTING_CITIES, payload: true });
        });
};
